import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as image from "../../resources/images";
import MainLayOut from "../MainLayOut/MainLayOut";

import 'chart.js/auto';
import { ShimmerContentBlock } from "react-shimmer-effects";
import { breadcrumb, enrollModal, selectType, showModal } from "../../redux/actions";
import { dashBoardAchivements, dashBoardCourseGoal, dashBoardParentInfo, getDashboardAllPlan, getDashboardLearnerPlan, getPlanCourseGoal, getPlanSchedule } from "../../redux/actions/APIs";
import { datesorting, getAlluserCourses, getCalculatePlanDate, getCalenderViewData, getCapitalized, getCurrentDaysOfWeek, getName, getSequnceSort,getProfileName, textTrim } from "../../utils/helper";
import DonutChart from "../base/DonutChart";
import LineChart from "../base/LineChart";
import ParentStaticDashBoardGraph from "./ParentStaticDashBoardGraph";
import ChildStaticDashBoardGrapsh from "./ChildStaticDashBoardGrapsh";

const DashboardGraph = () => {

    const dispatch = useDispatch();
    const { loggedInUser,
        defaultChildData,
        dashBoardParentData,
        dashBoardLearnerData,
        dashBoardAllPlanData,
        getUserPLanResp,
        planScheduleData,
        modalData,
        planCourseGoalData,
        dashBoardCourseGoalData,
        dashBoardAchivementData
    } = useSelector(
        (state) => state.collections
    );
    const [selectChild, setSelectChild] = useState();
    const [planIndex, setPlanIndex] = useState(0);
    const [selectedPlan, setSelectedPlan] = useState();
    const [calenderData, setCalenderData] = useState([]);
    const [courseIndex, setCourseIndex] = useState(0);
    const [selectedCourse, setSelectedCourse] = useState();
    const [userDate, setUserDate] = useState(new Date());
    const [isCollapse, setIsCollapse] = useState(false);

    useEffect(() => {
        if (loggedInUser?.children?.length > 0) {
            setSelectChild(datesorting(loggedInUser?.children)[0]);
        } else if (loggedInUser) {
            setSelectChild(loggedInUser);
        }
    }, [loggedInUser])

    useEffect(() => {
        if (defaultChildData || selectChild) {
            let userId = selectChild?.id ? selectChild?.id : defaultChildData?.id;
            dispatch(getDashboardAllPlan(userId));
        }

    }, [defaultChildData, selectChild])

    /*
    useEffect(() => {
        if (dashBoardAllPlanData) {
            let myPlanId = ""
            if (dashBoardAllPlanData?.records?.length > 0 && !myPlanId) {
                myPlanId = dashBoardAllPlanData?.records[0]?.planId;
            }
            if (loggedInUser?.role?.name === "PARENT") {
                let body = { planId: myPlanId }
                dispatch(dashBoardParentInfo(defaultChildData?.id, body));
            } else if (loggedInUser?.role?.name === "LEARNER") {
                dispatch(getDashboardLearnerPlan(defaultChildData?.id, myPlanId));
                dispatch(dashBoardAchivements(defaultChildData?.id, myPlanId))
            }

        }
    }, [dashBoardAllPlanData])
    */

    useEffect(() => {
        if (dashBoardAllPlanData?.records?.length > 0 && selectChild) {
            let getMyPlanData = getSequnceSort(dashBoardAllPlanData?.records).reverse()[planIndex];
            let myPlanId = getMyPlanData?.planId;
            let userId = loggedInUser?.role?.name === "PARENT" ? loggedInUser?.id : selectChild?.id;
            setSelectedPlan(getMyPlanData);
            dispatch(getPlanSchedule(selectChild?.id, myPlanId));
            dispatch(dashBoardCourseGoal(userId, selectChild?.id, myPlanId));
            if (loggedInUser?.role?.name === "PARENT") {
                let body = { planId: myPlanId }
                dispatch(dashBoardParentInfo(selectChild?.id, body));
            } else if (loggedInUser?.role?.name === "LEARNER") {
                dispatch(getDashboardLearnerPlan(selectChild?.id, myPlanId));
                dispatch(dashBoardAchivements(selectChild?.id, myPlanId))
            }
        }
         if (dashBoardAllPlanData?.records?.length === 0 ) {
            dispatch(showModal({ type: "DashBoardEmptyPopUp" }));
        }
    }, [planIndex, dashBoardAllPlanData]);

    // console.log("dashBoardAllPlanData", dashBoardAllPlanData && getSequnceSort(dashBoardAllPlanData?.records).reverse(), planIndex);

    const handleChildTab = (childObj) => {
        setPlanIndex(0);
        setCourseIndex(0);
        setSelectChild(childObj);
        dispatch(dashBoardParentInfo());
    };

    useEffect(() => {
        dispatch(breadcrumb({ title: "📈 Dashboard" }));
    }, [])

    const handleMyPlan = (planInd) => {
        //  console.log('click :', planInd);
        if (planInd >= 0 && planInd < dashBoardAllPlanData?.records?.length) {
            setPlanIndex(planInd);
            setCourseIndex(0);
            handleCollapse();
        }
    }

    useEffect(() => {
        if (planScheduleData?.records?.length > 0) {
            let tempPlanData = planScheduleData?.records[0];
            let weekArr = tempPlanData?.dayOfWeek ? tempPlanData?.dayOfWeek?.split(",") : getCurrentDaysOfWeek(userDate, tempPlanData?.sittings);
            let getScheduleCourses = getCalculatePlanDate(
                tempPlanData?.courses,
                tempPlanData?.duration,
                tempPlanData?.sittings,
                tempPlanData?.planStartDate,
                weekArr,
            );
            dispatch(
                showModal({
                    type: "",
                    data: getScheduleCourses,
                    getUserTimeZone: loggedInUser?.timeZone ? loggedInUser?.timeZone : "US/Eastern",
                    dayOfWeek: weekArr,
                    holidays: [],
                })
            );
        }
    }, [planScheduleData]);

    // console.log("enrollment halfAScreen ", selectedSitting, selectedMinutes, getFlexibLeDays, selctedDays, response);
    useEffect(() => {
        if (modalData?.data?.length > 0) {
            let calenderArr = getCalenderViewData(modalData);
            let calenderSesonsData = calenderArr?.filter((week) =>
                week?.find((item) => item?.courseName)
            );
            setCalenderData(calenderSesonsData);
        }
    }, [modalData]);

    /*
    useEffect(() => {
        if (planCourseGoalData?.records?.length > 0) {
            let getCourseObj = getSequnceSort(planCourseGoalData?.records)[courseIndex];
            setSelectedCourse(getCourseObj);
        }
    }, [planCourseGoalData, courseIndex]);
    */

    const toggleAccordion = (index) => {
        setCourseIndex(courseIndex === index ? null : index);
    }

    const handleEditPlan = () => {
        dispatch(getPlanSchedule(selectChild?.id, selectedPlan?.planId));
        dispatch(selectType("edit"));
        dispatch(enrollModal([]));
    }

    const handlePlanGoals = (courseIndex) => {
        let dashBoardPlanData = dashBoardCourseGoalData;
        dashBoardPlanData.courseIndex = courseIndex;
        dashBoardPlanData.planId = selectedPlan?.planId;
        dispatch(showModal({
            type: "PlanGoals", dashBoardPlanData: dashBoardPlanData, childData: selectChild
        }));
    }

    const handleCollapse = () => {
        setIsCollapse(!isCollapse);
    }

    

   
    // console.log("getUserPLanResp : ",dashBoardLearnerData, selectedCourse, planScheduleData, getUserPLanResp, dashBoardAllPlanData, selectedPlan, calenderData);

    console.log("dashBoardParentData : ", dashBoardParentData, );

    return (
        <MainLayOut>
            <div className="leftpannel min-width-100">
                <div className="LeftpanelContent">
                    <div className="coursecatalogcontainer planpage_  ">
                        {loggedInUser?.role?.name === "PARENT" && (
                            <div className="learnertablist pt-3 pb-3  flexone">
                            <div className="chilprofiles My_Profile flexone ">
                                <p className="mr-3">Learners:</p>
                                <ul className="flexthree mr-auto">
        
                                {loggedInUser?.children?.length > 0 &&
                                    datesorting(loggedInUser?.children)?.map((child, index) => (
                                        <li	className={`text-center ${child?.id === selectChild?.id && "Active_tab"} ${loggedInUser?.children?.length === 1 ? "singlechildtab" : ""} pointer`} onClick={() => handleChildTab(child)}>  
                                                {child.imageUrl ? (<img src={child.imageUrl} alt="childimg"  />
                                            ):(
                                                <span class="user_initials m-0">{getProfileName(child)}</span>
                                            )}
                                            
                                            
                                            
                                            {/* {textTrim(getCapitalized(getName(child), 18))} */}
                                            
                                            {/* {console.log(child,"child")} */}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        )}
                    
                        {loggedInUser && (
                            <>
                                {loggedInUser?.role?.name === "PARENT" ? (
                                    <div className="mydashboardgrid">
                                        <h2 className="flexone plan_dropdwn pb-4 position-relative">                                     
                                           <span className="dashboardplan_name pointer"> {textTrim(selectedPlan?.planName, 30)}</span>
                                           <div class="mytoottiptxt p-3">
                                           <p class="p1 mb-1">{selectedPlan?.planName}</p>
                                         
                                           </div>
                                            <></>
                                            {/* {selectedPlan?.planName?.length > 0 && ( */}
                                                <>
                                                <div className="updownarrow ml-2 pointer">
                                                <span class="border-0 pointer flexfive"
                                                    data-toggle="collapse"
                                                    data-target="#myplanname"
                                                    aria-expanded="false"
                                                    onClick={()=>handleCollapse()}
                                                    >
                                                    <i class="fa-solid fa-angle-down"></i>
                                                    </span>
                                                                    
                                                
                                                    {/* <span onClick={() => handleMyPlan(planIndex - 1)}><i class="fa-regular fa-angle-up"></i></span>
                                                    <span onClick={() => handleMyPlan(planIndex + 1)}><i class="fa-regular fa-angle-down"></i></span> */}
                                                    {/*
                                                <span onClick={() => handleMyPlan(planIndex - 1)}>
                                                     <i class="fa-regular fa-angle-up"></i>
                                                </span>
                                                <span onClick={()=>handleMyPlan(planIndex+1)}>
                                                    <i class="fa-regular fa-angle-down"></i>
                                                </span>
                                                */}
                                                </div>
                                                 <ul className={`panel-collapse planname_list collapse ${isCollapse && "show"}`}
                                                  id="#myplanname" 
										          aria-expanded="true"
                                                   >

                                                   {dashBoardAllPlanData?.records?.length > 0 &&
                                                        getSequnceSort(dashBoardAllPlanData?.records).reverse()?.map((plan, index) => (
                                                            <li  key={index} className="pointer" onClick={() => handleMyPlan(index)} >
                                                                <p className="p2"> {plan?.planName}</p>
                                                            </li>
                                                        ))
                                                }
                                               </ul>
                                               </>
                                          
                                        </h2>
                                        {dashBoardAllPlanData?.records?.length === 0 ? (
                                             <ParentStaticDashBoardGraph /> 
                                        ): (
                                            <div className="dashboard-grid">
                                            <div className="dashboard-card">
                                                <h3 className="card-title">Plan Completion Breakdown</h3>
                                                <div className="card-divider"></div>
                                                <div className=" ">
                                                   
                                                    {dashBoardParentData?.records?.length > 0 ? dashBoardParentData?.records?.map((data, index) => (
                                                        <div className="flexone donutchartwd ">
                                                            <DonutChart planCompletion={data?.planCompletion} />
                                                            <div className="chart-legend" key={index}>
                                                                <div className="legend-item">
                                                                    <div
                                                                        className="legend-color"
                                                                        style={{ backgroundColor: " #85b812" }}
                                                                    ></div>
                                                                    <div className="legend-text">{data?.planCompletion?.completed}% Completed</div>
                                                                </div>
                                                                <div className="legend-item">
                                                                    <div
                                                                        className="legend-color"
                                                                        style={{ backgroundColor: "#a86adb" }}
                                                                    ></div>
                                                                    <div className="legend-text">{data?.planCompletion?.progress}% In Progress</div>
                                                                </div>
                                                                <div className="legend-item">
                                                                    <div
                                                                        className="legend-color"
                                                                        style={{ backgroundColor: "#e46666" }}
                                                                    ></div>
                                                                    <div className="legend-text">{data?.planCompletion?.notStarted}% Not Started</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )) : (
                                                        <p className="dbdefaulttxt p1">
                                                        <p><i class="fa-solid fa-circle-exclamation"></i></p>
                                                        <p> Let’s get started! Create your first plan to generate insights and stay on track.</p>
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="dashboard-card">
                                                <h3 className="card-title">Weekly Activity Trend</h3>
                                                <div className="card-divider"></div>
                                                <div className="activity-chart p-0">
                                                    {/* <div className="chart-y-axis">
                                                        <span className="chart-y-label">Minutes Watched</span>
                                                        <span className="chart-y-label">5</span>
                                                        <span className="chart-y-label">5</span>
                                                        <span className="chart-y-label">5</span>
                                                        <span className="chart-y-label">5</span>
                                                        <span className="chart-y-label">5</span>
                                                        <span className="chart-y-label">5</span>
                                                    </div> */}
                                                    {/* <img src="../assets/images/img_mask_group.png" alt="Activity Chart" style={{marginLeft: '40px', width: '350px', height: '171px'}} /> */}

                                                    {dashBoardParentData?.records?.length > 0 ? (
                                                        <LineChart weekActivitData={dashBoardParentData?.records[0]?.weeklyActivities} />
                                                    ) : (
                                                          <p className="dbdefaulttxt p1">
                                                          <p><i class="fa-solid fa-circle-exclamation"></i></p>
                                                           <p> Let’s get started! Create your first plan to generate insights and stay on track.</p>
                                                        </p>
                                                    )}

                                                    {/* <div className="chart-x-axis">
                                                        <span className="chart-x-label">1</span>
                                                        <span className="chart-x-label">2</span>
                                                        <span className="chart-x-label">3</span>
                                                        <span className="chart-x-label">4</span>
                                                    </div>
                                                    <div style={{textAlign: 'center' , marginTop: '5px'}}>
                                                        <span className="chart-x-label">Weeks</span>
                                                    </div> */}
                                                </div>
                                            </div>

                                            {
                                                /*
                                                    Module Compliation data
                                                */
                                            }
                                            <div className="dashboard-card ">
                                                <h3 className="card-title">Achievements &amp; Milestones</h3>
                                                <div className="card-divider"></div>
                                                {
                                                    dashBoardParentData?.records?.length > 0 ? (
                                                        <>
                                                        {(()=>{
                                                            const getAchivmentObj = dashBoardParentData?.records[0]?.achievement;
                                                            console.log("getAchivmentObj : ", getAchivmentObj);
                                                            return(
                                                               <>
                                                                {getAchivmentObj?.courseName ? (
                                                                    <div className="achievement-list">
                                                                        <div className="achievement-item">
                                                                            <img src={getAchivmentObj?.currentBadgeImageUrl ? getAchivmentObj?.currentBadgeImageUrl : ""} alt="Medal" className="achievement-icon" />
                                                                            <div className="achievement-text">{getAchivmentObj?.badgeName}</div>
                                                                        </div>
                                                                        <div className="achievement-item">
                                                                            <img src={image.fireicon} alt="Fire" className="achievement-icon" />
                                                                            <div className="achievement-text">{getAchivmentObj?.streak}</div>
                                                                        </div>
                                                                        <div className="achievement-item">
                                                                            <img src={getAchivmentObj?.courseImageUrl ? getAchivmentObj?.courseImageUrl : ""} alt="Trophy" className="achievement-icon" />
                                                                            <div className="achievement-text">{getAchivmentObj?.courseName}</div>
                                                                        </div>
                                                                    </div>
                                                                    ) : (
                                                                    <p className="dbdefaulttxt p1">
                                                            
                                                                        <p><i class="fa-solid fa-circle-exclamation"></i></p>
                                                                            Great start! Now it's time to take action — explore your course and start earning your first badge!
                                                                        </p>
                                                                    )
                                                                }
                                                               </> 
                                                            )
                                                        })()}  
                                                        </>
                                                    ) : (
                                                       <p className="dbdefaulttxt p1">
                                                    
                                                                   <p><i class="fa-solid fa-circle-exclamation"></i></p>
                                                            Let’s get started! Create your first plan to generate insights and stay on track.
                                                        </p>
                                                    )
                                                }
                                            </div>


                                            <div className="dashboard-card okr-section">
                                                <div className="okr-header">
                                                    <h2 className="card-title" style={{ marginBottom: ' 0' }}>Plan OKRs Overview</h2>
                                                    {/* <img src="../assets/images/img_humbleiconsarrowup.svg" alt="Arrow" width="24" height="24" /> */}
                                                    {
                                                        /*
                                                        <div className="view-all">
                                                            <span>View All Plans</span>                                                        
                                                            <i class="fa-regular fa-arrow-right-long ml-3"></i>
                                                        </div>
                                                        */
                                                    }
                                                </div>
                                                {
                                                    dashBoardCourseGoalData?.records?.length > 0 ? (
                                                        <div className="okr-itemhead">
                                                            <div className="okr-item-header active">
                                                                <div className="okr-item-title flexone w-100" >
                                                                    <h3 className='h-3 flexone w-100'>{selectedPlan?.planName} <p class="p2" onClick={()=>handleEditPlan()}><a href="javascript:void(0)" className="a2"><sapn><i class="fa-solid fa-pen mr-2"></i>Edit Plan</sapn></a></p></h3>
                                                                    {/* <span className="dropdwnicon" ><i class="fa-regular fa-angle-down"></i></span> */}
                                                                </div>
                                                            </div>
                                                            {getSequnceSort(dashBoardCourseGoalData?.records)?.map((course, index) => (
                                                                <div className="okr-item" key={index}>
                                                                    <div className="okr-item-header" data-target="teamwork">
                                                                        <div className="okr-item-title">{course?.courseName}</div>
                                                                        <div className="flexone">
                                                                            {!course?.isComic && (
                                                                                <span className="mr-3 pr-3 " onClick={()=>handlePlanGoals(index)}><a href="javascript:void(0)" className="a3 setgoalsedit flexone"><i class="fa-light fa-circle-plus mr-2"></i>{!course?.isDefinedGoal &&  !course?.isCompleted ? "Set Goals" : "Edit Goals"}</a></span>
                                                                            )}
                                                                            
                                                                            {/* <img src="../assets/images/img_vector_cyan_400.svg" alt="Expand" width="14" height="7" /> */}
                                                                            <span
                                                                                class="dropdwnicon border-0 pointer flexfive"
                                                                                href={"#showCourseGooal" + index}
                                                                                aria-expanded={courseIndex === index}
                                                                                onClick={() => toggleAccordion(index)}
                                                                            ><i class="fa-regular fa-angle-down"></i></span>
                                                                        </div>
                                                                    </div>
                                                                    <div className={` panel-collapse collapse okr-item-content ${courseIndex === index ? "show" : ""}  lifeeventlist populattags Child_challenges parents_challenge`}
                                                                        id={"showCourseGooal" + index}>
                                                                        <div className="okr-divider"></div>
                                                                        <div className="okr-row">
                                                                            <div className="okr-label">Goal</div>
                                                                            <div className="okr-value">{course?.goal?.name}</div>
                                                                        </div>
                                                                        {getSequnceSort(course?.goal?.keyResults)?.map((goal, key) => (
                                                                            <div className="checkbox" key={key}>
                                                                                <div className='okr-label'>
                                                                                    <div className="Ansoptions checkboxtyped">
                                                                                        <label className="selAnslabel ">
                                                                                         <div className="checkbox-label">KR {key + 1}</div>
                                                                                            {/* <span className="tagName">Boosting Confidence & Resiliance</span> */}
                                                                                            <input type="checkbox" name="knowledgecheck" disabled={true} checked={goal?.isCompleted} />
                                                                                            <span class="checkmark"></span>
                                                                                        </label>
                                                                                    </div>

                                                                                </div>
                                                                                <div className="checkbox-text">{goal?.keyName}</div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <p className="dbdefaulttxt p1">
                                                    
                                                                   <p><i class="fa-solid fa-circle-exclamation"></i></p>
                                                            Let’s get started! Create your first plan to generate insights and stay on track.
                                                        </p>
                                                    )
                                                }
                                            </div>
                                            <div className="dashboard-card schedule-section calendarSchedule">
                                                <div className="schedulecontainer">
                                                    <div className="schedule-header">
                                                        <h2 className="card-title" style={{ marginBottom: '0' }}>Plan Schedule</h2>
                                                        {/* <img src="../assets/images/img_vector_white_a700_9x9.svg" alt="Add" width="9" height="9" /> */}
                                                        {
                                                            /*
                                                            <div className="add-button">                                                            
                                                                <i class="fa-solid fa-plus"></i>
                                                            </div>
                                                            */
                                                        }
                                                    </div>
                                                    {
                                                        calenderData?.length > 0 ? (
                                                            <div className="schedulecalender ">
                                                                <div className="flexone w-100 mt-5">
                                                                    <div className="calander-days week-day-only">
                                                                        <p>Week</p>
                                                                    </div>
                                                                    <div className="calander-days">
                                                                        <p>Monday</p>
                                                                    </div>
                                                                    <div className="calander-days">
                                                                        <p>Tuesday</p>
                                                                    </div>
                                                                    <div className="calander-days">
                                                                        <p>Wednesday</p>
                                                                    </div>
                                                                    <div className="calander-days">
                                                                        <p>Thursday</p>
                                                                    </div>
                                                                    <div className="calander-days">
                                                                        <p>Friday</p>
                                                                    </div>
                                                                    <div className="calander-days">
                                                                        <p>Saturday</p>
                                                                    </div>
                                                                    <div className="calander-days">
                                                                        <p>Sunday</p>
                                                                    </div>
                                                                </div>

                                                                {/* Calendar Date */}

                                                                {calenderData?.map((weeks, index) => {
                                                                    const currentWeek = weeks?.find((item) => item?.courseName);
                                                                    return (
                                                                        <div className="flexone w-100 mt-3">
                                                                            <div className="calander-date-min-div week" key={index}>
                                                                                <div className="calander-date-title week-date-title ">
                                                                                    <p className="p3">
                                                                                        {weeks[0]?.date} - {weeks[6]?.date}
                                                                                    </p>

                                                                                </div>
                                                                                <p className="pt-4 p2 fw-500 weekName ">
                                                                                    Week {index + 1}
                                                                                </p>
                                                                            </div>
                                                                            {weeks?.map((days, key) => (
                                                                                <>
                                                                                    {days?.courseName ? (
                                                                                        <div className="calander-date-min-div active-date">
                                                                                            <div className="calander-date-title active-date-title">
                                                                                                <p className="p3">{days?.date}

                                                                                                </p>

                                                                                            </div>
                                                                                            <div className="d-flex justify-content-start pl-2">
                                                                                                <p className="pt-4 p4 fw-500 calander-date-sub-title">
                                                                                                    C{days.courseKey}: {days?.courseName}
                                                                                                </p>
                                                                                            </div>
                                                                                            <div className="d-flex justify-content-start pt-2 pl-2">
                                                                                                <i
                                                                                                    className="fa fa-caret-right mr-1"
                                                                                                    aria-hidden="true"
                                                                                                ></i>
                                                                                                <p className="calander-date-sub-title1  p3 text-uppercase">
                                                                                                    M{days?.moduleKey}: {days?.moduleName}
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div key={key} className="calander-date-min-div">
                                                                                            <div className="calander-date-title">
                                                                                                <p className="p3">{days?.date}</p>
                                                                                            </div>
                                                                                            <p className="pt-4 p2 fw-500"></p>
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            ))}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        ) : (
                                                            <p className="dbdefaulttxt p1">
                                                    
                                                                   <p><i class="fa-solid fa-circle-exclamation"></i></p>
                                                                Let’s get started! Create your first plan to generate insights and stay on track.
                                                            </p>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        )}                                        
                                    </div>
                                ) : (
                                    <div className="mydashboardgrid">
                                        <h2 className="flexone plan_dropdwn pb-4 position-relative">
                                            {/* Plan Overview */}
                                           <span className="dashboardplan_name pointer">  {textTrim(selectedPlan?.planName, 30)}  </span>
                                               <div class="mytoottiptxt p-3">
                                           <p class="p1 mb-1">{selectedPlan?.planName}</p>
                                         
                                           </div>
                                                <>
                                                <div className="updownarrow ml-2 pointer">
                                                    <span class="border-0 pointer flexfive"
                                                    data-toggle="collapse"
                                                    data-target="#myplanname"
                                                        aria-expanded="false"
                                                    onClick={()=>handleCollapse()}
                                                    >
                                                    <i class="fa-solid fa-angle-down"></i>
                                                    </span>
                                                </div>
                                                <ul className={`panel-collapse planname_list collapse ${isCollapse && "show"}`}
                                                  id="#myplanname" 
                                                  
                                                >
                                                {dashBoardAllPlanData?.records?.length > 0 &&
                                                        getSequnceSort(dashBoardAllPlanData?.records).reverse()?.map((plan, index) => (
                                                            <li  key={index} className="pointer" onClick={() => handleMyPlan(index)} >
                                                                <p className="p2"> {plan?.planName}</p>
                                                            </li>
                                                        ))
                                                }
                                               </ul>
                                            </>
                                        </h2>
                                         {dashBoardAllPlanData?.records?.length === 0 ? (
                                                <ChildStaticDashBoardGrapsh />
                                            ) : (
                                                <div className="dashboard-grid">
                                            <div className="dashboard-card okr-section">
                                                <div className="okr-header">
                                                    <h3 className="card-title" style={{ marginBottom: " 0" }}>
                                                        Plan Progress Tracker
                                                    </h3>
                                                </div>
                                                <div className="">
                                                    <div className="moduleComplete_progress progess_navigation flexthree">
                                                        {
                                                            dashBoardLearnerData?.records?.length > 0 ? 
                                                            getSequnceSort(dashBoardLearnerData?.records)?.map((course, index) => (
                                                                
                                                                                <div className={`modulecpItems ${course?.activites?.every((item) => item?.isCompleted) && "completed_modules"}`} key={index}>
                                                                    <div className="mymodule_name">
                                                                        <p className="p2">
                                                                            {course?.name}
                                                                        </p>
                                                                    </div>
                                                                    <ul>
                                                                        {getSequnceSort(course?.activites)?.map((module, key) => {
                                                                            let icon = null;

                                                                            if (!module?.isUnlock) {
                                                                                icon = <i className="fa-solid fa-lock-keyhole"></i>;
                                                                            } else if (module?.inProgress) {
                                                                                icon = <i className="fa-solid fa-spinner"></i>; // Use a valid Font Awesome icon
                                                                            } else if (module?.isCompleted) {
                                                                                icon = <i className="fa-solid fa-check"></i>;
                                                                            }

                                                                            return (
                                                                                <li key={module?.id}>
                                                                                <span className="circleone">{icon}</span>
                                                                                </li>
                                                                            );
                                                                        })}

                                                                    </ul>
                                                                </div>    
                                                                )
                                                            ) : (
                                                               <p className="dbdefaulttxt p1">
                                                    
                                                                   <p><i class="fa-solid fa-circle-exclamation"></i></p>
                                                                    Let’s get started! Create your first plan to generate insights and stay on track.
                                                                </p>
                                                            )
                                                        }
                                                        {/* <div className="modulecpItems completed_modules">
                                                            <div className="mymodule_name">
                                                                <p className="p2">
                                                                    Confident You: Believe In Yourself
                                                                </p>
                                                            </div>
                                                            <ul>
                                                                <li>
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-check"></i>
                                                                    </span>
                                                                </li>
                                                                <li>
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-check"></i>
                                                                    </span>
                                                                </li>
                                                                <li>
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-check"></i>
                                                                    </span>
                                                                </li>
                                                                <li>
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-check"></i>
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="modulecpItems">
                                                            <div className="mymodule_name">
                                                                <p className="p2">
                                                                    Understanding Why Teamwork Matters
                                                                </p>
                                                            </div>
                                                            <ul>
                                                                <li>
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-check"></i>
                                                                    </span>
                                                                </li>
                                                                <li>
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-spinner-scale"></i>
                                                                    </span>
                                                                </li>
                                                                <li className="locked_modules">
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-lock-keyhole"></i>
                                                                    </span>
                                                                </li>
                                                                <li className="locked_modules">
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-lock-keyhole"></i>
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="modulecpItems">
                                                            <div className="mymodule_name">
                                                                <p className="p2">
                                                                    Developing Super-Human Problem Skills
                                                                </p>
                                                            </div>
                                                            <ul>
                                                                <li className="locked_modules">
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-lock-keyhole"></i>
                                                                    </span>
                                                                </li>
                                                                <li className="locked_modules">
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-lock-keyhole"></i>
                                                                    </span>
                                                                </li>
                                                                <li className="locked_modules">
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-lock-keyhole"></i>
                                                                    </span>
                                                                </li>
                                                                <li className="locked_modules">
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-lock-keyhole"></i>
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="modulecpItems ">
                                                            <div className="mymodule_name">
                                                                <p className="p2">
                                                                    Breathwork To Awaken Your Super Energy
                                                                </p>
                                                            </div>
                                                            <ul>
                                                                <li className="locked_modules">
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-lock-keyhole"></i>
                                                                    </span>
                                                                </li>
                                                                <li className="locked_modules">
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-lock-keyhole"></i>
                                                                    </span>
                                                                </li>
                                                                <li className="locked_modules">
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-lock-keyhole"></i>
                                                                    </span>
                                                                </li>
                                                                <li className="locked_modules">
                                                                    <span class="circleone">
                                                                        <i class="fa-solid fa-lock-keyhole"></i>
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="dashboard-card childdashboradach">
                                                <h3 className="card-title">Achievements &amp; Milestones</h3>
                                                <div className="card-divider"></div>
                                                {
                                                    dashBoardAchivementData?.records?.length > 0 ? (
                                                        <>
                                                            {dashBoardAchivementData?.records[0]?.courseName ? (
                                                                <div className="achievement-list">
                                                                    {dashBoardAchivementData?.records?.map((data, index) => (
                                                                        <>
                                                                            <div className="achievement-item">
                                                                                <img
                                                                                    src={data?.currentBadgeImageUrl ? data?.currentBadgeImageUrl : ""}
                                                                                    alt="Medal"
                                                                                    className="achievement-icon"
                                                                                />
                                                                                <div className="achievement-text">
                                                                                    {data?.badgeName}
                                                                                </div>
                                                                            </div>
                                                                            <div className="achievement-item">
                                                                                <img
                                                                                    src={image.fireicon}
                                                                                    alt="Fire"
                                                                                    className="achievement-icon"
                                                                                />
                                                                                <div className="achievement-text">
                                                                                    {data?.streak}
                                                                                </div>
                                                                            </div>
                                                                            <div className="achievement-item">
                                                                                <img
                                                                                    src={data?.courseImageUrl ? data?.courseImageUrl : ""}
                                                                                    alt="Trophy"
                                                                                    className="achievement-icon"
                                                                                />
                                                                                <div className="achievement-text">
                                                                                    {data?.courseName}
                                                                                </div>
                                                                            </div>
                                                                            <div className="achievement-item">
                                                                                <img
                                                                                    src={image.medal_icon}
                                                                                    alt="medal"
                                                                                    className="achievement-icon"
                                                                                />
                                                                                <div className="achievement-text">
                                                                                    {data?.rank}
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                <p className="dbdefaulttxt p1">
                                                    
                                                                   <p><i class="fa-solid fa-circle-exclamation"></i></p>
                                                                    Great start! Now it's time to take action — explore your course and start earning your first badge!
                                                                </p>
                                                            )}
                                                        </>
                                                    ) : (
                                                       <p className="dbdefaulttxt p1">
                                                    
                                                                   <p><i class="fa-solid fa-circle-exclamation"></i></p>
                                                            Let’s get started! Create your first plan to generate insights and stay on track.
                                                        </p>
                                                    )
                                                }
                                            </div>

                                            <div className="dashboard-card okr-section">
                                                <div className="okr-header">
                                                    <h3 className="card-title" style={{ marginBottom: ' 0' }}>Plan OKRs Overview</h3>
                                                    {/* <img src="../assets/images/img_humbleiconsarrowup.svg" alt="Arrow" width="24" height="24" /> */}
                                                    {
                                                        /*
                                                        <div className="view-all">
                                                            <span>View All Plans</span>                                                        
                                                            <i class="fa-regular fa-arrow-right-long ml-3"></i>
                                                        </div>
                                                        */
                                                    }
                                                </div>
                                                {
                                                    dashBoardCourseGoalData?.records?.length > 0 ? (
                                                        <div className="okr-itemhead">
                                                            <div className="okr-item-header active">
                                                                <div className="okr-item-title flexone w-100" >
                                                                    <h3 className='h-3 flexone w-100'>{selectedPlan?.planName} <p class="p2" onClick={()=>handleEditPlan()}><a href="javascript:void(0)" className="a2"><sapn><i class="fa-solid fa-pen mr-2"></i>Edit Plan</sapn></a></p></h3>
                                                                    {/* <span className="dropdwnicon" ><i class="fa-regular fa-angle-down"></i></span> */}
                                                                </div>
                                                            </div>
                                                            {getSequnceSort(dashBoardCourseGoalData?.records)?.map((course, index) => (
                                                                <div className="okr-item" key={index}>
                                                                    <div className="okr-item-header" data-target="teamwork">
                                                                        <div className="okr-item-title">{course?.courseName}</div>
                                                                        <div className="flexone">
                                                                           {!course?.isComic && (
                                                                                <span className="mr-3 pr-3 " onClick={()=>handlePlanGoals(index)}><a href="javascript:void(0)" className="a3 setgoalsedit flexone"><i class="fa-light fa-circle-plus mr-2"></i>{!course?.isDefinedGoal &&  !course?.isCompleted ? "Set Goals" : "Edit Goals"}</a></span>
                                                                            )}
                                                                            {/* <img src="../assets/images/img_vector_cyan_400.svg" alt="Expand" width="14" height="7" /> */}
                                                                            <span
                                                                                class="dropdwnicon border-0 pointer flexfive"
                                                                                href={"#showCourseGooal" + index}
                                                                                aria-expanded={courseIndex === index}
                                                                                onClick={() => toggleAccordion(index)}
                                                                            ><i class="fa-regular fa-angle-down"></i></span>
                                                                        </div>
                                                                    </div>
                                                                    <div className={` panel-collapse collapse okr-item-content ${courseIndex === index ? "show" : ""}  lifeeventlist populattags Child_challenges parents_challenge`}
                                                                        id={"showCourseGooal" + index}>
                                                                        <div className="okr-divider"></div>
                                                                        <div className="okr-row">
                                                                            <div className="okr-label">Goal</div>
                                                                            <div className="okr-value">{course?.goal?.name}</div>
                                                                        </div>
                                                                        {getSequnceSort(course?.goal?.keyResults)?.map((goal, key) => (
                                                                            <div className="checkbox" key={key}>
                                                                                <div className='okr-label'>
                                                                                    <div className="Ansoptions checkboxtyped">
                                                                                        <label className="selAnslabel ">
                                                                                         <div className="checkbox-label">KR {key + 1}</div>
                                                                                            {/* <span className="tagName">Boosting Confidence & Resiliance</span> */}
                                                                                            <input type="checkbox" name="knowledgecheck" disabled={true} checked={goal?.isCompleted} />
                                                                                            <span class="checkmark"></span>
                                                                                        </label>
                                                                                    </div>

                                                                                </div>
                                                                                <div className="checkbox-text">{goal?.keyName}</div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <p className="dbdefaulttxt p1">
                                                    
                                                                   <p><i class="fa-solid fa-circle-exclamation"></i></p>
                                                            Let’s get started! Create your first plan to generate insights and stay on track.
                                                        </p>
                                                    )
                                                }


                                            </div>
                                            <div className="dashboard-card schedule-section calendarSchedule">
                                                <div className="schedulecontainer">
                                                    <div className="schedule-header">
                                                        <h3 className="card-title p-0" style={{ marginBottom: '0' }}>Plan Schedule</h3>
                                                        {/* <div className="add-button">                                                            
                                                            <i class="fa-solid fa-plus"></i>
                                                        </div> */}
                                                    </div>
                                                    {
                                                        calenderData?.length > 0 ? (
                                                            <div className="schedulecalender ">
                                                                <div className="flexone w-100 mt-5">
                                                                    <div className="calander-days week-day-only">
                                                                        <p>Week</p>
                                                                    </div>
                                                                    <div className="calander-days">
                                                                        <p>Monday</p>
                                                                    </div>
                                                                    <div className="calander-days">
                                                                        <p>Tuesday</p>
                                                                    </div>
                                                                    <div className="calander-days">
                                                                        <p>Wednesday</p>
                                                                    </div>
                                                                    <div className="calander-days">
                                                                        <p>Thursday</p>
                                                                    </div>
                                                                    <div className="calander-days">
                                                                        <p>Friday</p>
                                                                    </div>
                                                                    <div className="calander-days">
                                                                        <p>Saturday</p>
                                                                    </div>
                                                                    <div className="calander-days">
                                                                        <p>Sunday</p>
                                                                    </div>
                                                                </div>

                                                                {/* Calendar Date */}
                                                                {calenderData?.map((weeks, index) => {
                                                                    const currentWeek = weeks?.find((item) => item?.courseName);
                                                                    return (
                                                                        <div className="flexone w-100 mt-3">
                                                                            <div className="calander-date-min-div week" key={index}>
                                                                                <div className="calander-date-title week-date-title ">
                                                                                    <p className="p3">
                                                                                        {weeks[0]?.date} - {weeks[6]?.date}
                                                                                    </p>

                                                                                </div>
                                                                                <p className="pt-4 p2 fw-500 weekName ">
                                                                                    Week {index + 1}
                                                                                </p>
                                                                            </div>
                                                                            {weeks?.map((days, key) => (
                                                                                <>
                                                                                    {days?.courseName ? (
                                                                                        <div className="calander-date-min-div active-date">
                                                                                            <div className="calander-date-title active-date-title">
                                                                                                <p className="p3">{days?.date}

                                                                                                </p>

                                                                                            </div>
                                                                                            <div className="d-flex justify-content-start pl-2">
                                                                                                <p className="pt-4 p4 fw-500 calander-date-sub-title">
                                                                                                    C{days.courseKey}: {days?.courseName}
                                                                                                </p>
                                                                                            </div>
                                                                                            <div className="d-flex justify-content-start pt-2 pl-2">
                                                                                                <i
                                                                                                    className="fa fa-caret-right mr-1"
                                                                                                    aria-hidden="true"
                                                                                                ></i>
                                                                                                <p className="calander-date-sub-title1  p3 text-uppercase">
                                                                                                    M{days?.moduleKey}: {days?.moduleName}
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div key={key} className="calander-date-min-div">
                                                                                            <div className="calander-date-title">
                                                                                                <p className="p3">{days?.date}</p>
                                                                                            </div>
                                                                                            <p className="pt-4 p2 fw-500"></p>
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            ))}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        ) : (
                                                         <p className="dbdefaulttxt p1">
                                                    
                                                                   <p><i class="fa-solid fa-circle-exclamation"></i></p>
                                                                Let’s get started! Create your first plan to generate insights and stay on track.
                                                            </p>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                            )}                                        
                                    </div>
                                )}
                            </>
                        )}

                    </div>
                </div>
            </div>
        </MainLayOut>
    );
}
export default DashboardGraph